export default __webpack_public_path__ + "static/media/trr-drink-specialty-detox.8de31d99.png";